/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoTraceCoreMember } from './OutputGeoTraceCoreMember';
import {
    OutputGeoTraceCoreMemberFromJSON,
    OutputGeoTraceCoreMemberFromJSONTyped,
    OutputGeoTraceCoreMemberToJSON,
} from './OutputGeoTraceCoreMember';

/**
 * 
 * @export
 * @interface OutputGeoTraceCore
 */
export interface OutputGeoTraceCore {
    /**
     * 
     * @type {boolean}
     * @memberof OutputGeoTraceCore
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCore
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCore
     */
    lon?: number;
    /**
     * 
     * @type {Array<OutputGeoTraceCoreMember>}
     * @memberof OutputGeoTraceCore
     */
    members?: Array<OutputGeoTraceCoreMember>;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCore
     */
    spreadKm?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceCore interface.
 */
export function instanceOfOutputGeoTraceCore(value: object): boolean {
    return true;
}

export function OutputGeoTraceCoreFromJSON(json: any): OutputGeoTraceCore {
    return OutputGeoTraceCoreFromJSONTyped(json, false);
}

export function OutputGeoTraceCoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceCore {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(OutputGeoTraceCoreMemberFromJSON)),
        'spreadKm': json['spreadKm'] == null ? undefined : json['spreadKm'],
    };
}

export function OutputGeoTraceCoreToJSON(value?: OutputGeoTraceCore | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'active': value['active'],
        'lat': value['lat'],
        'lon': value['lon'],
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(OutputGeoTraceCoreMemberToJSON)),
        'spreadKm': value['spreadKm'],
    };
}

